import { Component, ViewChild, Input } from '@angular/core';
import { LoginService } from '@app/login/services';
import { CustomerSwitchStatus } from '@app/ngrx-customer/constants/customer-switch-status';
import { CustomerStoreService } from '@app/ngrx-customer/services';
import { MessageTypeEnum } from '@app/ngrx-message/constants/messageTypeEnum';
import { Message } from '@app/ngrx-message/models/client/message';
import { MessageStoreService } from '@app/ngrx-message/services/message/message-store.service';
import { IonInput } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { PlatformService } from '@panamax/app-state';
import { ZipCodeChangeBaseComponent } from '@shared/components/header/zip-code-change/zip-code-change-base.component';
import { ZipCodeFormatPipe } from '@shared/components/header/pipes/zipCodeFormat';
import { ToastMessages } from '@shared/constants/toast-messages.enum';
import { Subscription } from 'rxjs';
import { ZipCodeAnalyticsService } from '@shared/components/header/zip-code-change/tracking/analytics/zip-code.analytics.service';
import { ZipCodeAnalyticsMessages } from '@shared/components/header/zip-code-change/tracking/analytics/models/zip-code-messages.analytics';

@Component({
  selector: 'app-zip-code-banner',
  templateUrl: './zip-code-banner.component.html',
  styleUrls: ['./zip-code-banner.component.scss'],
})
export class ZipCodeBannerComponent extends ZipCodeChangeBaseComponent {
  @ViewChild('input') zipCodeInput: IonInput;
  @Input() isGuestUser = false;
  isMobile: boolean;
  isTablet: boolean;
  customerSwitchSub$: Subscription;
  zipCodeSub$: Subscription;
  constructor(
    platformService: PlatformService,
    loginService: LoginService,
    private customerStoreService: CustomerStoreService,
    private messageStoreService: MessageStoreService,
    private translateService: TranslateService,
    private zipCodeFormatPipe: ZipCodeFormatPipe,
    private zipCodeAnalyticsService: ZipCodeAnalyticsService,
  ) {
    super(platformService, loginService);
  }

  async switchGuestZip(event: any) {
    this.zipCodeInput.getInputElement().then(input => input.blur());
    if (this.isValidZipCode()) {
      await this.loginService.switchGuestZip(Number(this.zipCodeValue));
      this.zipCodeAnalyticsService.trackZipCodeSwitchClick(
        ZipCodeAnalyticsMessages.modalNameBanner,
        Number(this.zipCodeValue),
      );
    } else {
      this.messageStoreService.upsertMessage({
        type: MessageTypeEnum.error,
        display: this.translateService.instant(ToastMessages.guestSwitchError),
        toast: true,
        sticky: false,
      } as Message);
      this.zipCodeValue = this.loginService.zipCode$.value.toString();
    }
  }

  onInit() {
    this.isMobile =
      this.platformService.platformType ===
      this.platformService.platformEnum.mobile;
    this.isTablet =
      this.platformService.platformType ===
      this.platformService.platformEnum.tablet;
    this.zipCodeSub$ = this.loginService.zipCode$.subscribe(zipCode => {
      if (zipCode)
        this.zipCodeValue = this.zipCodeFormatPipe.transform(
          zipCode.toString(),
        );
    });
    this.customerSwitchSub$ = this.customerStoreService
      .customerSwitchStatus$()
      .subscribe(status => {
        if (status === CustomerSwitchStatus.failed) {
          this.zipCodeValue = this.loginService.zipCode$.value.toString();
        }
      });
  }

  onDestroy() {
    this.customerSwitchSub$?.unsubscribe();
    this.zipCodeSub$?.unsubscribe();
  }

  keyDownValidation(event: KeyboardEvent): boolean {
    if (/[0-9]/.test(event.key)) return true;
    return this.keyDownZipCodeValidation(event);
  }
}
